//LIPSYNC_MODELS = lipsync models with type = "normal"

export enum TWIN_STUDIO_TABS {
    LIPSYNC_MODELS = "High quality twins",
    ZERO_SHOT = "Express Twins",
    SYNTHETICS = "Synthetic portraits",
    PHOTO_TWIN = "Photo Twin",
  }
